export enum ClaimStepsEnum {
  CONFIRM = 1,
  AMOUNT,
  WITHDRAWAL,
  FINISH
}
